export enum ClientId {
  ControLimit = 1,
  MetaFacil = 2,
  CountDown = 3,
  ProductControl = 4,
  TatuGestor = 5,
  CartaoVirtual = 6,
  JaAssistiu = 7,
}
